/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ApproveInputs */

const th_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อนุมัติ`)
};

const en_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

const ja_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認`)
};

const zh_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批准`)
};

const es_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar`)
};

const pt_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovar`)
};

const id_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setujui`)
};

const fr_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuver`)
};

const tl_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprubahan`)
};

const vi_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt`)
};

const ko_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`승인`)
};

const de_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freigeben`)
};

const ru_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одобрить`)
};

const tr_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onayla`)
};

const it_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approva`)
};

const pl_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatwierdź`)
};

const uk_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Схвалити`)
};

const hi_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वीकृत करें`)
};

const ar_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموافقة`)
};

const ms_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luluskan`)
};

const bn_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুমোদন`)
};

const zh_tw2_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核准`)
};

const zh_hk2_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核准`)
};

const ur_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منظور کریں`)
};

const fa_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأیید`)
};

const sw_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idhinisha`)
};

const nl_approve = /** @type {(inputs: ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goedkeuren`)
};

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {ApproveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const approve = /** @type {((inputs?: ApproveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ApproveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_approve(inputs)
	if (locale === "ja") return ja_approve(inputs)
	if (locale === "zh") return zh_approve(inputs)
	if (locale === "es") return es_approve(inputs)
	if (locale === "pt") return pt_approve(inputs)
	if (locale === "id") return id_approve(inputs)
	if (locale === "fr") return fr_approve(inputs)
	if (locale === "tl") return tl_approve(inputs)
	if (locale === "vi") return vi_approve(inputs)
	if (locale === "ko") return ko_approve(inputs)
	if (locale === "de") return de_approve(inputs)
	if (locale === "ru") return ru_approve(inputs)
	if (locale === "tr") return tr_approve(inputs)
	if (locale === "it") return it_approve(inputs)
	if (locale === "pl") return pl_approve(inputs)
	if (locale === "uk") return uk_approve(inputs)
	if (locale === "hi") return hi_approve(inputs)
	if (locale === "ar") return ar_approve(inputs)
	if (locale === "ms") return ms_approve(inputs)
	if (locale === "bn") return bn_approve(inputs)
	if (locale === "zh-TW") return zh_tw2_approve(inputs)
	if (locale === "zh-HK") return zh_hk2_approve(inputs)
	if (locale === "ur") return ur_approve(inputs)
	if (locale === "fa") return fa_approve(inputs)
	if (locale === "sw") return sw_approve(inputs)
	if (locale === "nl") return nl_approve(inputs)
	return en_approve(inputs)
});